
/* Home hero: concept 1 on phones/tablets, concept 2 on desktop (1024px+ landscape). Only the active concept animates; paused when the hero is off screen. */
(function(){
  'use strict';
  var d=document, w=window, b=d.body;
  var hero=d.getElementById('hero'); if(!hero) return;
  var reduce=w.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var visible=true;
  if ('IntersectionObserver' in w){ new IntersectionObserver(function(e){ visible=e[0].isIntersecting; }, {threshold:[0,0.35,1]}).observe(hero); }
  function now(){ return w.performance.now(); }
  function clamp(v,a,c){ return v<a?a:(v>c?c:v); }
  function ease(t){ return t<.5 ? 4*t*t*t : 1-Math.pow(-2*t+2,3)/2; }
  var mqD=w.matchMedia('(min-width:1024px) and (orientation:landscape)');
  function isDesk(){ return mqD.matches; }
  // gate(): true while this concept is the one on screen
  function loop(fn, gate){ (function f(){ if(visible && !d.hidden && (!gate || gate())) fn(now()); w.requestAnimationFrame(f); })(); }

  /* ---------- Concept 1: lifestyle window synced to the rotating word ---------- */
  var win=hero.querySelector('.hc1-window');
  if (win){
    var slides=[].slice.call(win.querySelectorAll('.hc1-slide'));
    var imgs=slides.map(function(s){ return s.querySelector('img'); });
    var bars=[].slice.call(win.querySelectorAll('.hc1-bars b'));
    var chip=win.querySelector('.hc1-chip');
    var words=slides.map(function(s){ return s.dataset.word; });
    var cur=-1, prev=-1, tChange=0, starts=slides.map(function(){ return -1e9; }), period=2600;
    function show(i, t){
      if (i===cur) return;
      prev=cur; cur=i; tChange=t; starts[i]=t;
      var s=slides[i];
      chip.style.opacity=0;
      setTimeout(function(){
        chip.innerHTML='<a class="hc-chip" href="'+s.dataset.href+'"><i>'+s.dataset.word+'</i>'+s.dataset.name+' <b>↗</b></a>';
        chip.style.opacity=1;
      }, reduce?0:300);
    }
    w.addEventListener('ijs:word', function(e){
      var wd=(e.detail&&e.detail.word)||''; var i=words.indexOf(wd);
      if (i<0 && e.detail) i=e.detail.index % slides.length;
      show(i, now());
    });
    show(0, now()-(reduce?2000:0));
    if (reduce){
      // no camera moves; a calm swap of the photo every few seconds (the rotating word is static in reduced motion)
      bars.forEach(function(x){ x.parentNode.style.display='none'; });
      setInterval(function(){ if(!isDesk()) show((cur+1)%slides.length, now()); }, 4200);
    }
    loop(function(t){
      var fade=reduce?600:1100, k=clamp((t-tChange)/fade,0,1);
      slides.forEach(function(s,i){
        var o = i===cur ? k : (i===prev ? 1 : 0);
        if (i===prev && k>=1) o=0;
        s.style.opacity=o; s.style.zIndex = i===cur?2:(i===prev?1:0);
        if (!reduce && (i===cur || i===prev)){
          var p=clamp((t-starts[i])/(period+fade+400),0,1);
          var dir = i%2 ? -1 : 1;
          imgs[i].style.transform='scale('+(1.13-0.09*p).toFixed(4)+') translate3d('+(dir*(1.6-3.2*p)).toFixed(3)+'%,'+(1.2-1.6*p).toFixed(3)+'%,0)';
        }
      });
      bars.forEach(function(x,i){
        var v = i<cur ? 1 : (i===cur ? clamp((t-tChange)/period,0,1) : 0);
        x.style.transform='scaleX('+v.toFixed(4)+')';
      });
    }, function(){ return !isDesk(); });
  }

  /* ---------- Concept 2: showroom turntable (same timing as concept-2.html) ---------- */
  var stage=hero.querySelector('.hc2-stage');
  if (stage){
    var disc=stage.querySelector('.hc2-disc');
    var items=[].slice.call(stage.querySelectorAll('.hc2-item'));
    var label=stage.querySelector('.hc2-label');
    var N=items.length, slot=Math.PI*2/N, L={};
    items.forEach(function(el){ el._ar=parseFloat(el.dataset.ar)||1; el._hf=parseFloat(el.dataset.hf)||1; });
    function measure(){
      var sr=stage.getBoundingClientRect(), dr=disc.getBoundingClientRect();
      var ph=sr.width<700;
      L.cx=sr.width/2; L.cy=(dr.top-sr.top)+dr.height*0.42; L.R=dr.width*(ph?0.33:0.39); L.r=dr.height*0.36;
      L.base=Math.min(sr.height*(ph?0.62:0.66), (dr.top-sr.top)+dr.height*0.5-8, ph?250:270);
    }
    function m2(){ if(isDesk()) measure(); }
    m2(); w.addEventListener('resize', m2);
    if (mqD.addEventListener) mqD.addEventListener('change', m2); else if (mqD.addListener) mqD.addListener(m2);
    if (d.fonts && d.fonts.ready) d.fonts.ready.then(m2);
    var move=950, hold=1750, step=move+hold, t0=now(), lastFront=-1;
    function setLabel(i){
      var el=items[i];
      label.innerHTML='<a class="hc-chip" href="'+el.dataset.href+'"><i>Shop</i>'+el.dataset.name+' <b>↗</b></a>';
    }
    loop(function(t){
      var e=t-t0, pos, moving=false;
      if (reduce){ pos=0; }
      else {
        var n=Math.floor(e/step), r=e-n*step;
        if (r<hold){ pos=n; } else { pos=n+ease((r-hold)/move); moving=true; }
      }
      var front=((Math.round(pos)%N)+N)%N;
      items.forEach(function(el,i){
        var th=(i-pos)*slot, c=Math.cos(th), depth=(c+1)/2;
        var sc=0.42+0.58*Math.pow(depth,1.4);
        var h=L.base*el._hf*sc, wd=h*el._ar;
        var x=L.cx+L.R*Math.sin(th)-wd/2, y=L.cy+L.r*c-h;
        el.style.height=h.toFixed(1)+'px'; el.style.width=wd.toFixed(1)+'px';
        el.style.transform='translate3d('+x.toFixed(1)+'px,'+y.toFixed(1)+'px,0)';
        el.style.zIndex=Math.round(depth*40);
        el.style.opacity=clamp(0.25+depth*2.6,0,1).toFixed(3);
      });
      if (front!==lastFront){ lastFront=front; setLabel(front); }
      var lo = reduce ? 1 : (moving ? 0 : clamp(((e%step))/350,0,1));
      label.firstChild && (label.firstChild.style.opacity=lo, label.firstChild.style.transform='translateY('+((1-lo)*6).toFixed(1)+'px)');
    }, isDesk);
  }
})();
